import { render, staticRenderFns } from "./RegistrationOverview.vue?vue&type=template&id=aa297fb4&scoped=true&"
import script from "./RegistrationOverview.vue?vue&type=script&lang=js&"
export * from "./RegistrationOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa297fb4",
  null
  
)

export default component.exports